import { useQuery } from '@apollo/client';
import React from 'react';
import css from '@emotion/css';
import styled from '@emotion/styled';
import { CircularProgress } from '@material-ui/core';
import { useQueryHelper } from '../../../../libs/hooks';
import AnalyticsContentWrapper, { ContentType } from '../../AnalyticsShared/AnalyticsContentWrapper';
import { AnalyticsPeriodWithId } from '../../AnalyticsShared/types';
import Overview from './InteractionOverview';
import * as IG_INTERACTION_OVERVIEW from './InstagramInteractionOverview.graphql';
import {
  InstagramInteractionOverview,
  InstagramInteractionOverviewVariables
} from './__generated__/InstagramInteractionOverview';

const InteractionOverview = ({ period, id }: AnalyticsPeriodWithId) => {
  const { history, enqueueSnackbar, t } = useQueryHelper();
  const { data, loading, error } = useQuery<InstagramInteractionOverview, InstagramInteractionOverviewVariables>(
    IG_INTERACTION_OVERVIEW,
    {
      variables: { analyticsAccountId: id, startDate: period.startDate, endDate: period.endDate }
    }
  );

  if (loading) {
    return (
      <LoaderWrapper>
        <CircularProgress
          size={64}
          thickness={2.4}
          css={css`
            margin: 240px auto;
            color: #e0e8ed;
          `}
        />
      </LoaderWrapper>
    );
  }

  if (!data?.instagramInteractionOverview || error) {
    history.push('/analytics');
    const errorMsg = error?.message || 'Can not get analytics for current account';
    enqueueSnackbar(t(errorMsg), { variant: 'error' });

    return null;
  }

  return (
    <AnalyticsContentWrapper contentType={ContentType.Overview} tab="interaction">
      <Overview instagramInteractionOverview={data.instagramInteractionOverview} />
    </AnalyticsContentWrapper>
  );
};

const LoaderWrapper = styled.div`
  background-color: #fff;
  text-align: center;
  height: 554px;
`;

export default InteractionOverview;
